import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Input, FormGroup, Label } from "reactstrap";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import "../myReactSelect.css";
import swal from "@sweetalert/with-react";
import { baseurl } from "../../../../baseurl";
import axios from "axios";
import { GetIp } from "../../ShortCutComponents/Get_ip";
import ResponseLoader from "../../ShortCutComponents/ResponseLoader";
import { checkPermission } from "../../../../Helper";
export default function ItemForm(props) {
  var username = localStorage.getItem("username");
  var token = localStorage.getItem("token");
  var companyId = localStorage.getItem("companyId");
  const [loadingResponce, setLoadingResponce] = useState(false);
  const [data, setData] = useState({
    id1: "",
    desc1: "",
    showModalAddNew: true,
  });

  const toggleAddNew = (showModalAddNew) => {
    setData({ ...data, [showModalAddNew]: showModalAddNew });
    let uomId = data.uom?.id;
    if (uomId) props.toggle(uomId);
    else props.toggle();
  };

  const inputEvent = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setData({
      ...data,
      [name]: value,
    });
  };
  const validNumber = (e) => {
    console.log("in validNumber", e);
    let num = e.target.value?.toString().replaceAll(",", "");
    num = Number(num);
    console.log("num" + num);
    if (num <= 0 && data.defaultRateShow === "1") {
      swal({
        title: "Default rate should be more than 0",
        text: 'Default rate should be more than 0 when display rate on invoice is "Yes" ',
        icon: "warning",
      });
      setData({ ...data, defaultRate: 1 });
    } else {
      setData({
        ...data,
        defaultRate: num,
      });
    }
  };

  useEffect(() => {
    const funCall = async (value) => {
      const openModalCheck = await asyncRollCheck(value);
      if (openModalCheck) {
        toggleAddNew();
        return;
      }
    };
    if (props.EditData > -1) {
      funCall(2);
      let resData;
      let tableId = props.EditData;

      axios
        .post(
          `${baseurl}/OneCateg/getOnePlanById`,
          { id: tableId, companyId: companyId, username: username },
          {
            headers: {
              authorization: token,
            },
          }
        )
        .then((res) => {
          resData = res.data.data[0];

          console.log("resData :>> ", resData);

          let desc1 = resData["plan_desc"];
          setData({
            ...data,
            desc1,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      funCall(1);
    }
  }, []);
  const asyncRollCheck = async (value) => {
    let pathname = "/AddPlanForm";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };

  const getUserIp = async function () {
    let res = await GetIp();
    console.log(res);
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
  };
  const handleSubmitAddItem = async (event) => {
    event.preventDefault();
    console.warn(data);
    setLoadingResponce(true);

    var companyId = localStorage.getItem("companyId");
    const newRecord = { ...data };
    console.log(newRecord);
    console.log(companyId);
    let { userIp, userCountry } = await getUserIp();
    if (1 == 1) {
      if (props.EditData > -1) {
        let Id = props.EditData;
        axios
          .post(
            `${baseurl}/OneCateg/updateOnePlan`,
            {
              Id,
              companyId,
              desc1: data.desc1,
              username: username,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )

          .then(function (response) {
            setLoadingResponce(false);
            console.log(response.data);
            if (response.data.duplicate === true) {
              swal({
                title: "Duplicate Code is not Allowed",
                text: "Duplicate Entry",
                icon: "error",
              });
            } else {
              swal({
                title: "Success!",
                text: "Plan Updated!",
                icon: "success",
              }).then((value) => {
                toggleAddNew();
              });
            }
          })
          .catch(function (error) {
            console.log(error);
            setLoadingResponce(false);

            swal({
              title: "Error",
              text: "Something went wrong, try to refresh the page and try again.",
              icon: "error",
            });
          });
      } else {
        axios
          .post(
            `${baseurl}/OneCateg/AddOnePlan`,
            {
              companyId,
              desc1: data.desc1,
              username: username,
              userIp,
              userCountry,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then(function (response) {
            setLoadingResponce(false);
            if (response.data.duplicate === true) {
              swal({
                title: "Duplicate Code is not Allowed",
                text: "Duplicate Entry",
                icon: "error",
              });
            } else {
              swal({
                title: "Saved Successfully!",
                text: "Plan Added",
                icon: "success",
              }).then((value) => {
                toggleAddNew();
              });
            }
          })
          .catch(function (error) {
            console.log("erooor", error);
            setLoadingResponce(false);

            swal({
              title: "Error",
              text: "Something went wrong, try to refresh the page and try again.",
              icon: "error",
            });
          });
      }
    } else {
      setLoadingResponce(false);
    }
  };
  return (
    <>
      {loadingResponce ? (
        <ResponseLoader />
      ) : (
        <div>
          <Modal
            show={data.showModalAddNew}
            size="md"
            onHide={toggleAddNew}
            backdrop="static"
          >
            <Modal.Header
              closeButton
              onClick={toggleAddNew}
              className=" Creative-Invoice-header-styling"
            >
              <strong>
                <h4> {props.EditData > -1 ? "Update" : "Add"} Plan </h4>
              </strong>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col>
                  <div className="row">
                    <div className="col-md-12">
                      <Form name="simpleForm" onSubmit={handleSubmitAddItem}>
                        <div className="row">
                          <div
                            className="col-md-12"
                            style={{ marginBottom: "12px" }}
                          >
                            <Label style={{ fontWeight: "bold" }}>
                              Plan Description :
                            </Label>
                            <Input
                              value={data.desc1}
                              onChange={inputEvent}
                              required
                              name="desc1"
                              id="desc1"
                              isClearable
                            />
                          </div>
                        </div>
                        <hr
                          style={{
                            border: "1px solid ",
                            marginBottom: "3vh",
                            marginTop: "3vh",
                            borderColor: "E4E5E6",
                          }}
                        />
                        <FormGroup>
                          <Button className="mr-1 invoiceSubmitButton ">
                            {props.EditData > -1 ? "Update" : "Save"} Changes
                          </Button>
                          <Button
                            onClick={() => toggleAddNew()}
                            className="mr-1"
                            size="sm"
                          >
                            Cancel
                          </Button>
                        </FormGroup>
                      </Form>
                    </div>
                  </div>
                </Col>
              </Row>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </>
  );
}
